var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoCalling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.005,
    height: 20.005,
    viewBox: "0 0 20.005 20.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "so-calling",
    d: "M21.384,17.752a2.108,2.108,0,0,1-.522,3.359,7.543,7.543,0,0,1-5.476.642C10.5,20.523,3.477,13.5,2.247,8.614a7.543,7.543,0,0,1,.642-5.476,2.108,2.108,0,0,1,3.359-.522L8.333,4.7a2.094,2.094,0,0,1,.445,2.328A3.877,3.877,0,0,1,8,8.2c-2.384,2.384,5.417,10.185,7.8,7.8a3.877,3.877,0,0,1,1.173-.781,2.092,2.092,0,0,1,2.328.445ZM10.571,2.771a1,1,0,1,0,.858,1.806,6,6,0,0,1,7.994,7.994,1,1,0,0,0,1.807.858A8,8,0,0,0,10.571,2.771Zm4.844,10.057a1,1,0,0,0,1.414,0,4,4,0,1,0-5.657-5.656,1,1,0,1,0,1.414,1.414,2.048,2.048,0,0,1,2.829,0,2,2,0,0,1,0,2.828,1,1,0,0,0,0,1.414Z",
    transform: "translate(-1.998 -1.997)",
    fill: "#2772af"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoCalling);
export default __webpack_public_path__ + "static/media/so-calling.dc6c9ca376578192ec7930e13f062dd5.svg";
export { ForwardRef as ReactComponent };